const API_BASE = (import.meta as any).env?.VITE_API_BASE ?? 'https://app-xyqar-api.azurewebsites.net';
const WS_BASE  = API_BASE.replace(/^https?:/, (s: string) => (s === 'https:' ? 'wss:' : 'ws:'));
export { API_BASE, WS_BASE };
export async function apiGet<T = any>(p: string, t?: string): Promise<T> {
  const r = await fetch(`${API_BASE}${p}`, { headers: t ? { Authorization: `Bearer ${t}` } : {} });
  if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json();
}
export async function apiPost<T = any>(p: string, b: any, t?: string): Promise<T> {
  const r = await fetch(`${API_BASE}${p}`, { method: 'POST', headers: { 'Content-Type': 'application/json', ...(t ? { Authorization: `Bearer ${t}` } : {}) }, body: JSON.stringify(b) });
  if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json();
}
export async function apiPatch<T = any>(p: string, b: any, t?: string): Promise<T> {
  const r = await fetch(`${API_BASE}${p}`, { method: 'PATCH', headers: { 'Content-Type': 'application/json', ...(t ? { Authorization: `Bearer ${t}` } : {}) }, body: JSON.stringify(b) });
  if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json();
}
